import { Divider } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

type SectionVariant = 'field' | 'property';

const VARIANT_MARGIN_INLINE_START: Record<SectionVariant, string> = {
  field: '-8px',
  property: '-16px'
};

const VARIANT_MARGIN_INLINE_END: Record<SectionVariant, string> = {
  field: '-8px',
  property: '-42px'
};

export const SectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`;

export const SectionDivider = styled(Divider)<{ $variant: SectionVariant }>`
  margin-block: 4px;
  margin-inline-start: ${({ $variant }) => VARIANT_MARGIN_INLINE_START[$variant]};
  margin-inline-end: ${({ $variant }) => VARIANT_MARGIN_INLINE_END[$variant]};
  width: auto;
  border-color: ${COLOR_OPTIONS.NEUTRAL_20};
`;

export const SectionLabel = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${COLOR_OPTIONS.NEUTRAL_60};
  line-height: 18px;
  margin-top: -2px;
`;

export const SectionTagWrapper = styled.div<{ $variant: SectionVariant }>`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: ${({ $variant }) => ($variant === 'field' ? '4px' : '0')};
`;
